import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { Link } from "react-router-dom";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import NoData from "../../../assets/admin/images/no-data-found.svg";
import { Formik, Field, Form, ErrorMessage } from "formik";
import deleteaccountImg from "../../../assets/user/images/delete-account.svg";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import WhCalen from "../../../assets/user/images/whcalendar.svg";
import * as Yup from "yup";
import Loader from "../../../layouts/loader/Loader";
import { api } from "../../../utlis/admin/api.utlis";
import ApiService from "../../../core/services/ApiService";
import {
  totalPageCalculator,
  communityLIMIT,
  SingleFile,
  Loyalty,
  LogoFile,
} from "../../../utlis/common.utlis";
import moment from "moment/moment";
import toast from "react-hot-toast";

const Page = () => {
  const [blogs, setBlog] = useState([]);
  const [addBlog, setAddBlog] = useState({ status: false });
  const [deleteBlog, setDeleteBlog] = useState({ status: false, id: null });
  const [total, setTotal] = useState(0);
  const [pageNum, setPageNum] = useState(1);
  const [loading, setLoading] = useState(false);
  const [editBlog, setEditBlog] = useState({
    stat: false,
    id: null,
    title: null,
    slug: null,
    content: null,
    blog_image: null,
    status: null,
    created_date: null,
    author_name: null,
  });

  const initialValues = {
    title: "",
    content: "",
    blog_image: "",
    author_name: "",
  };

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Title is required!"),
    content: Yup.string()
      .required("Description is required!")
      .min(8, "Description must be 8 characters long."),
    blog_image: Yup.mixed()
      .required("Please upload your blog image")
      .test("fileSize", "File size is too large", (value) => {
        return value && value.size <= LogoFile * 1024 * 1024;
      })
      .test("fileType", "Unsupported file type", (value) => {
        return (
          value && ["image/jpeg", "image/png", "image/jpg"].includes(value.type)
        );
      }),
    author_name: Yup.string().nullable(),
  });

  const initialValuesEdit = {
    title: editBlog.title ?? "",
    content: editBlog.content ?? "",
    blog_image: "",
    author_name: editBlog.author_name ?? "",
  };

  const validationSchemaEdit = Yup.object().shape({
    title: Yup.string().required("Title is required!"),
    content: Yup.string()
      .required("Description is required!")
      .min(8, "Description must be 8 characters long."),
    blog_image: Yup.mixed()
      .test(
        "fileSize",
        `File size must be less than ${LogoFile} MB`,
        (value) => !value || (value && value.size <= LogoFile * 1024 * 1024)
      )
      .test("fileType", "Unsupported file type", (value) => {
        return value != "" && (value != null) & (value != undefined)
          ? ["image/jpeg", "image/png", "image/jpg"].includes(value.type)
          : true;
      }),
    author_name: Yup.string().nullable(),
  });

  const storeBlog = async (formValue) => {
    setLoading(true);
    const form = new FormData();
    form.append("title", formValue.title);
    form.append("content", formValue.content);
    form.append("blog_image", formValue.blog_image);
    form.append("author_name", formValue.author_name || "");
    const response = await ApiService.postAPIWithAccessTokenMultiPart(
      api.blogCreate,
      form
    );
    if (response.data.status) {
      setAddBlog({ status: false });
      getBlogList(api.blogList + `?page=${pageNum}&limit=${communityLIMIT}`);
      toast.success(response.data.message);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const updateBlog = async (formValue) => {
    setLoading(true);
    const form = new FormData();
    form.append("title", formValue.title);
    form.append("content", formValue.content);
    formValue.blog_image !== null &&
      form.append("blog_image", formValue.blog_image);
    form.append("author_name", formValue.author_name || "");
    const response = await ApiService.putAPIWithAccessTokenMultiPart(
      api.blogUpdate + `${editBlog.id}`,
      form
    );
    if (response.data.status) {
      setEditBlog({
        stat: false,
        id: null,
        title: null,
        slug: null,
        content: null,
        blog_image: null,
        status: null,
        created_date: null,
        author_name: null,
      });
      getBlogList(api.blogList + `?page=${pageNum}&limit=${communityLIMIT}`);
      toast.success(response.data.message);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const getBlogList = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log("all blogs list => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setBlog(response.data.data.blogs);
      setTotal(response.data.data.total);
    } else setBlog([]);
    setLoading(false);
  };

  const handleFilter = (e) => {
    e.persist();
    let name = "";
    if (e.target.name === "name") name = e.target.value;
    getBlogList(
      api.blogList + `?page=${pageNum}&limit=${communityLIMIT}&search=${name}`
    );
  };

  const handleImgChange = (e, setFieldValue) => {
    const file = e.target.files[0];
    if (file) {
      const fileSizeInMB = file.size / (1024 * 1024);
      const maxFileSize = SingleFile;
      if (fileSizeInMB > maxFileSize) {
        return;
      } else {
        setFieldValue("blog_image", e.target.files[0]);
      }
    }
  };

  const deleteBlogContent = async (id) => {
    setLoading(true);
    const response = await ApiService.deleteAPIWithAccessToken(
      api.blogDelete + `${id}`
    );
    setDeleteBlog({
      status: false,
      id: null,
    });
    if (response.data.status) {
      toast.success(response.data.message);
      getBlogList(api.blogList + `?page=${pageNum}&limit=${communityLIMIT}`);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getBlogList(api.blogList + `?page=${pageNum}&limit=${communityLIMIT}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNum]);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="content-wrapper">
        <div className="care-title-header">
          <h3 className="heading-title">Manage Blog </h3>
          <div className="cc-search-filter">
            <div className="row g-2">
              <div className="col-md-8">
                <div className="form-group search-form-group">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Search"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    onChange={(e) => handleFilter(e)}
                  />
                  <span className="search-icon">
                    <i className="cc-input-group-text  mdi mdi-magnify"></i>
                  </span>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <button
                    type="button"
                    className="btn-gr"
                    onClick={() => {
                      setAddBlog({ status: true });
                    }}
                  >
                    Add New Blog
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="care-content-coupon-list">
          <div className="row g-3">
            {blogs.length !== 0 ? (
              blogs.map((ele, indx) => {
                return (
                  <div key={indx} className="col-md-12 mb-3">
                    <div className="advertisement-card">
                      <div className="care-card-head">
                        <div className="care-id">{ele.title ?? "NA"}</div>
                        <div>
                          <Link
                            className="btn-gr"
                            to=""
                            onClick={() => {
                              setEditBlog({
                                stat: true,
                                id: ele.id,
                                title: ele.title,
                                slug: ele.slug,
                                content: ele.content,
                                status: ele.status,
                                created_date: ele.created_date,
                                blog_image: ele.blog_image,
                                author_name: ele.author_name ?? "",
                              });
                            }}
                          >
                            Edit
                          </Link>
                          <Link
                            className="btn-re mx-2"
                            to=""
                            onClick={() =>
                              setDeleteBlog({
                                status: true,
                                id: ele.id,
                              })
                            }
                          >
                            Delete
                          </Link>
                        </div>
                      </div>
                      <div className=" d-flex align-items-center px-3">
                        <div className="advertisement-image">
                          {ele.blog_image === null ||
                            ele.blog_image === "" ||
                            ele.blog_image === undefined ? (
                            <img
                              src={NoImage}
                              alt=""
                              height={100}
                              width={100}
                              style={{
                                objectFit: "cover",
                                objectPosition: "center",
                              }}
                            />
                          ) : (
                            <img
                              src={ele.blog_image}
                              alt=""
                              height={100}
                              width={100}
                              style={{
                                objectFit: "cover",
                                objectPosition: "center",
                              }}
                            />
                          )}
                        </div>
                        <div className="advertisement-content w-100">
                          <div className="d-flex justify-content-between">
                            <div className="care-status">
                              Status:{" "}
                              <span>
                                {ele.status == 1 ? "Active" : "Inactive"}
                              </span>
                            </div>
                          </div>
                          {/* ── Author Name ── */}
                          <div className="date-text mb-1">
                            <i className="mdi mdi-account me-1"></i>
                            <strong>Author: </strong>
                            <span>{ele.author_name || "Admin"}</span>
                          </div>
                          <div className="date-text mb-1">
                            <img src={WhCalen} alt="" />{" "}
                            {moment(ele.created_date).format(
                              "MM-DD-yyyy hh:mm A"
                            )}
                          </div>
                          <p className="mb-3">{ele.content ?? "NA"}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "5% 0",
                }}
              >
                <img width={300} src={NoData} alt="" />
              </div>
            )}
          </div>
          <div className="d-flex align-items-center justify-content-center mt-3">
            {blogs.length !== 0 ? (
              <div className="care-table-pagination">
                <ul className="care-pagination">
                  {pageNum !== 1 && (
                    <li
                      className="disabled"
                      id="example_previous"
                      onClick={() => setPageNum(pageNum - 1)}
                    >
                      <Link
                        to=""
                        aria-controls="example"
                        data-dt-idx="0"
                        tabIndex="0"
                        className="page-link"
                      >
                        Previous
                      </Link>
                    </li>
                  )}

                  {totalPageCalculator(total, communityLIMIT).length === 1
                    ? null
                    : totalPageCalculator(total, communityLIMIT).map(
                      (pageNo, indx) => {
                        return (
                          <li
                            className={pageNo === pageNum ? "active" : ""}
                            key={indx}
                            onClick={() => setPageNum(pageNo)}
                          >
                            <Link to="" className="page-link">
                              {pageNo}
                            </Link>
                          </li>
                        );
                      }
                    )}

                  {pageNum !== Math.ceil(total / communityLIMIT) && (
                    <li
                      className="next"
                      id="example_next"
                      onClick={() => setPageNum(pageNum + 1)}
                    >
                      <Link
                        to=""
                        aria-controls="example"
                        data-dt-idx="7"
                        tabIndex="0"
                        className="page-link"
                      >
                        Next
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <Modal
        show={editBlog.status}
        onHide={() => {
          setEditBlog({
            stat: false,
            id: null,
            title: null,
            slug: null,
            content: null,
            blog_image: null,
            status: null,
            created_date: null,
            author_name: null,
          });
        }}
        className="cc-modal-form modal-xl"
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">Edit Blog</h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row">
              <Formik
                initialValues={initialValuesEdit}
                validateOnChange={true}
                validationSchema={validationSchemaEdit}
                onSubmit={updateBlog}
              >
                {({ values, setFieldValue }) => (
                  <Form className="findcare-form">
                    <div className="row g-2">
                      <div className="col-md-12">
                        <div className="form-group">
                          <h4>Blog Title</h4>
                          <Field
                            type="text"
                            className="form-control todo-list-input"
                            name="title"
                            placeholder="Blog Title"
                          />
                          <ErrorMessage
                            name="title"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <h4>Author Name</h4>
                          <Field
                            type="text"
                            className="form-control todo-list-input"
                            name="author_name"
                            placeholder="Author Name (optional)"
                          />
                          <ErrorMessage
                            name="author_name"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group">
                          <h4>Blog Description</h4>
                          <Field
                            as="textarea"
                            className="form-control todo-list-input"
                            name="content"
                            placeholder="Enter Description"
                            rows="10"
                          />
                          <ErrorMessage
                            name="content"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group">
                          <h4>
                            Blog Image{" "}
                            <span
                              className="text-danger"
                              style={{ fontSize: "0.7rem" }}
                            >
                              (In JPG, JPEG, PNG)
                            </span>
                          </h4>
                          <Field name="blog_image">
                            {({ field, form }) => (
                              <div>
                                <input
                                  type="file"
                                  multiple
                                  accept="image/jpg, image/jpeg, image/png, application/pdf, .docx"
                                  className="form-control"
                                  onChange={(event) =>
                                    handleImgChange(event, setFieldValue)
                                  }
                                />
                              </div>
                            )}
                          </Field>
                          <ErrorMessage
                            name="blog_image"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form-group text-end mb-0">
                      <button
                        type="button"
                        onClick={() => {
                          setEditBlog({
                            stat: false,
                            id: null,
                            title: null,
                            slug: null,
                            content: null,
                            blog_image: null,
                            status: null,
                            created_date: null,
                          });
                        }}
                        className="btn-re me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn-gr"
                        data-bs-dismiss="modal"
                      >
                        Update Blog
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={deleteBlog.status}
        onHide={() => {
          setDeleteBlog({
            status: false,
            id: null,
          });
        }}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="deleteaccount-Img">
                <img src={deleteaccountImg} />
              </div>
              <div className="deleteaccount-text mb-4">
                <h5 className="text-center pb-0">Delete Blog</h5>
                <p className="text-center">
                  This action can't be undone. Do you really want to delete this
                  blog?
                </p>
              </div>
              <div className="form-group text-center">
                <button
                  type="button"
                  onClick={() =>
                    setDeleteBlog({
                      status: false,
                      id: null,
                    })
                  }
                  className="btn-wh-re me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-re me-2"
                  data-bs-dismiss="modal"
                  onClick={() => deleteBlogContent(deleteBlog.id)}
                >
                  Yes! Delete
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={addBlog.status}
        onHide={() => {
          setAddBlog({
            status: false,
          });
        }}
        className="cc-modal-form modal-xl"
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">Add New Blog</h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row">
              <Formik
                initialValues={initialValues}
                validateOnChange={true}
                validationSchema={validationSchema}
                onSubmit={storeBlog}
              >
                {({ values, setFieldValue }) => (
                  <Form className="findcare-form">
                    <div className="row g-2">
                      <div className="col-md-12">
                        <div className="form-group">
                          <h4>Blog Title</h4>
                          <Field
                            type="text"
                            className="form-control todo-list-input"
                            name="title"
                            placeholder="Blog Title"
                          />
                          <ErrorMessage
                            name="title"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>


                      <div className="col-md-12">
                        <div className="form-group">
                          <h4>Author Name</h4>
                          <Field
                            type="text"
                            className="form-control todo-list-input"
                            name="author_name"
                            placeholder="Author Name (optional)"
                          />
                          <ErrorMessage
                            name="author_name"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group">
                          <h4>Blog Description</h4>
                          <Field
                            as="textarea"
                            className="form-control todo-list-input"
                            name="content"
                            placeholder="Enter Description"
                            rows="10"
                          />
                          <ErrorMessage
                            name="content"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group">
                          <h4>
                            Blog Image{" "}
                            <span
                              className="text-danger"
                              style={{ fontSize: "0.7rem" }}
                            >
                              (In JPG, JPEG, PNG)
                            </span>
                          </h4>
                          <Field name="blog_image">
                            {({ field, form }) => (
                              <div>
                                <input
                                  type="file"
                                  multiple
                                  accept="image/jpg, image/jpeg, image/png, application/pdf, .docx"
                                  className="form-control"
                                  onChange={(event) =>
                                    handleImgChange(event, setFieldValue)
                                  }
                                />
                              </div>
                            )}
                          </Field>
                          <ErrorMessage
                            name="blog_image"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form-group text-end mb-0">
                      <button
                        type="button"
                        onClick={() => {
                          setAddBlog({
                            status: false,
                          });
                        }}
                        className="btn-re me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn-gr"
                        data-bs-dismiss="modal"
                      >
                        Create New Blog
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  );
};

export default Page;
